import { collapseNotificationBursts, DEFAULT_NOTIFICATION_BURST_MS } from './notification-burst-collapse.js';

/**
 * Colapsar ráfagas en sessionStorage tras globalShowNotification.
 * No alterar `detail` ni `component.lang`: el texto sale de las claves message_* del API y this.lang del host.
 */

// Hosts que heredan CommonCore (addEventListener success/error en firstUpdated).
// Incluir áreas raíz (p. ej. area-proc-definition): muchas acciones no pasan por elem-table en el composedPath.
const TRAZIT_CORE_HOST_TAGS = new Set([
  'COMMON-CORE',
  'ELEM-TABLE',
  'BUTTON-PANEL',
  'ELEM-CARDS',
  'AREA-PROC-DEFINITION',
  'AREA-ADMIN-MAIN'
]);

const kWrapped = Symbol('trazitGlobalNotifLangWrapped');

export function isSuccessOrErrorFromTrazitCoreHost(event) {
  if (typeof event?.composedPath !== 'function') return false;
  if (event.type !== 'success' && event.type !== 'error') return false;
  try {
    return event.composedPath().some(
      (n) => n && n.tagName && TRAZIT_CORE_HOST_TAGS.has(n.tagName)
    );
  } catch {
    return false;
  }
}

function wrapWithSessionLang(fn) {
  if (fn[kWrapped]) return fn;
  const wrapped = function (component, detail, isError, customColor, position) {
    const ret = fn.call(this, component, detail, isError, customColor, position);
    try {
      const raw = JSON.parse(sessionStorage.getItem('notifs') || '[]');
      const collapsed = collapseNotificationBursts(raw, DEFAULT_NOTIFICATION_BURST_MS);
      if (JSON.stringify(collapsed) !== JSON.stringify(raw)) {
        sessionStorage.setItem('notifs', JSON.stringify(collapsed));
      }
    } catch (_) {
      /* ignore */
    }
    return ret;
  };
  wrapped[kWrapped] = true;
  return wrapped;
}

let _hooked = false;

/**
 * Se ejecuta al importar este módulo. Intercepta la asignación a window.globalShowNotification
 * (p. ej. al cargar @trazit/common-core) y envuelve la función aunque common-core vaya en chunk aparte.
 */
function hookWindowGlobalShowNotification() {
  if (_hooked || typeof window === 'undefined') return;
  const desc = Object.getOwnPropertyDescriptor(window, 'globalShowNotification');
  if (desc && !desc.configurable) return;
  _hooked = true;

  let value = window.globalShowNotification;
  Object.defineProperty(window, 'globalShowNotification', {
    configurable: true,
    enumerable: true,
    get() {
      return value;
    },
    set(next) {
      if (typeof next === 'function' && !next[kWrapped]) {
        value = wrapWithSessionLang(next);
      } else {
        value = next;
      }
    }
  });
  if (typeof value === 'function' && !value[kWrapped]) {
    window.globalShowNotification = value; // pasa por setter
  }
}

hookWindowGlobalShowNotification();
// Por si un chunk cargó common-core antes que este módulo (p. ej. orden de deps en dev)
queueMicrotask(() => {
  try {
    const cur = window.globalShowNotification;
    if (typeof cur === 'function' && !cur[kWrapped]) {
      window.globalShowNotification = cur;
    }
  } catch (_) {
    /* ignore */
  }
});
